import React from 'react';
import { string, bool, object, func } from 'prop-types';
import DocumentDisplayName from '../../../../../../DocumentDisplayName';
import { issueAttributesType } from '../../../../../../../constants/proptype-validation';
import hiddenIcon from '../../../../../../../assets/images/icons/icon-eye-strikethrough.svg';
import visibleIcon from '../../../../../../../assets/images/icons/icon-eye.svg';
import PushpinVisibilityIcon from './PushpinVisibilityIcon';
import DocumentActionsMenu from './DocumentActionsMenu';

const DocumentDescription = ({ issue, allowLink, issueStartingVersion, document, container, isChangingPushpinVisibility, isDeletingPushpin, handleDocumentAction, canDeletePushpin = false }) => {

  const { id: issueId } = issue;

  return <div className="LinkedDocumentInlineEdit__document-details" data-testid="LinkedDocumentInlineEdit__document-details">
    <PushpinVisibilityIcon {...{ issue, container, hiddenIcon, visibleIcon }} />
    <DocumentDisplayName
      document={document} issueStartingVersion={issueStartingVersion} issueId={issueId}
      allowLink={allowLink}
    />
    <DocumentActionsMenu {...{ container, issue, isChangingPushpinVisibility, isDeletingPushpin, hiddenIcon, visibleIcon, handleDocumentAction, canDeletePushpin }} />
  </div>;
};

DocumentDescription.propTypes = {
  allowLink: bool.isRequired,
  issueStartingVersion: string,
  document: object,
  issue: issueAttributesType.isRequired,
  container: object.isRequired,
  isChangingPushpinVisibility: bool.isRequired,
  isDeletingPushpin: bool.isRequired,
  handleDocumentAction: func.isRequired,
  canDeletePushpin: bool,
};

export default DocumentDescription;
